module.exports = __webpack_public_path__ + "static/img/gdxq1.4df46174.png";